export default "__VITE_PUBLIC_ASSET__571c4635__"